import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { RouterService } from './router.service';

export const ngxRouterServiceModule = angular.module('ngxRouterServiceModule', [])
	.factory('ngxRouterService', downgradeInjectable(RouterService) as any)
	.name;
